<template>
    <div class="">
        <div class="content-wrapper" v-if="showForm == false">
            <div class="row">
                <div class="col-sm-12 col-md-6 bold-title ">
                    <app-breadcrumb :page-title="$t('product_title')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button type="button" class="btn btn-success btn-with-shadow" @click="exportAll">
                            {{ $t('export_all') }}
                        </button>


                        <button type="button" class="btn btn-primary btn-with-shadow" @click="showForm = true">
                            {{ $t('add') }}
                        </button>

                    </div>
                </div>
            </div>
            <!-- agregar formulario de productos -->


            <app-table v-if="showForm == false" :id="tableId" :options="options" @action="getListAction"
                :selected-url="selectedUrl" />

        </div>
        <add-product-form v-if="showForm" @close="showForm = false" :title="'add'" />

        <product-add-modal v-if="isAddEditModalActive" 
            :table-id="tableId" 
            :selected-url="selectedUrl"
            :modalTitle="titleModal"
            @close-modal="closeAddEditModal" 
            />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="demo-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl.js";
import { PRODUCTS_EXPORT } from "../../../Config/ApiUrl.js";
import { urlGenerator } from "../../../Helpers/AxiosHelper.js";

import { TableHelpers } from './mixins/TableHelpers.js';



export default {

    extends: CoreLibrary,
    name: "ProductsList",
    mixins: [TableHelpers],
    data() {
        return {
            titleModal : null,
            PRODUCTS_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            showForm: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'advance-table',
            rowData: {},
            options: {
                name: 'AdvanceTable',
                url: actions.PRODUCTS_DATA,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'product-add-modal',
                        modalId: 'product-add-edit-modal',

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'demo-delete',
                    },
                ],
                filters: [
                    {
                        "title": this.$t('date'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    },
                    {
                        title: this.$t('search_and_select'),
                        type: "search-and-select-filter",
                        key: "serverside_select",
                        settings: {
                            url: actions.PRODUCTS_SERVER_SEARCH_SELECT, // this url will hit every search action
                            modifire: (v) => {
                                return { id: v.id, name: v.name }
                            },
                            per_page: 10, // default 10, you can change it any number. min 10 encourage to use
                            queryName: 'search_selectable', // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
                            loader: 'app-pre-loader', // default app-overlay-loder
                            multiple: true, // default false, if you need to select multiple item so make it true
                            params: {
                                'type': 'type1',
                                'isWanted': true
                            }, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
                        },
                        listValueField: 'name'
                    },
                ],
                showFilter: false,
                showSearch: true,
                showCount: false,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },


    created() {
        this.options.columns = [...this.tableColumns, this.actionObj];
        this.searchAndSelectFilterOptions();
    },

    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            $("#product-add-edit-modal").modal('hide');
            $("#product-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.searchAndSelectFilterOptions();
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.PRODUCTS_DATA}/${rowData.id}`;
                this.titleModal = 'Edit';
                this.openAddEditModal();
            } else if(actionObj.title == this.$t('duplicate')){
                this.titleModal = 'Add';
                this.selectedUrl = `${actions.PRODUCTS_DATA}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.PRODUCTS_DATA}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {
            this.axiosGet(actions.PRODUCTS_SEARCH_SELECT).then(response => {
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));
                if (response.data && Array.isArray(response.data)) {
                    name.option = response.data.map(name => {
                        return {
                            id: name.name,
                            value: name.name
                        }
                    });
                }
            });
        },




        exportAll() {
            window.location.replace(urlGenerator(PRODUCTS_EXPORT))
        }
    },
}
</script>
